<ng-template #cellRendererTmpl let-record="record" let-column="column">
  <!-- uncomment to have compiler check template types
  <ng-container *ngIf="typedRecord(record); let record">
  <ng-container *ngIf="typedColumn(column); let column">
  -->
  <ng-container [ngSwitch]="column.name">

    <td *ngSwitchCase="'volunteerId'">
      
      <a *ngIf="roleMgr.isAdmin||roleMgr.canAssignScheduler||roleMgr.canSchedule else noEdit"
        href="javascript:false" 
        (click)="taskTable.editVolunteer(record)">{{
        record.volunteerId
      }}</a>
      <ng-template #noEdit>
        {{ record.volunteerId }}
      </ng-template>
    </td>

    <td *ngSwitchCase="'userName'">
      
      <a *ngIf="roleMgr.isAdmin||roleMgr.canAssignScheduler||roleMgr.canSchedule else noEdit"
        href="javascript:false" 
        (click)="taskTable.editVolunteer(record)">{{
        record.userName
      }}</a>
      <ng-template #noEdit>
        {{ record.userName }}
      </ng-template>
    </td>

    <td *ngSwitchCase="'carrier'"
      [ngClass]="'carrier carrier-'+(record.carrier|lowercase|replace:'-|[&)(]+':''|replace:' |/':'-')">      
        {{ record.carrier }}
    </td>

    <td *ngSwitchCase="'userStatus'"
      [ngClass]="'user-status-default user-status-'+record.userStatus">      
        {{ record.userStatus  | titlecase}}
    </td>

    <!-- did not find a cell renderer by column name so now try template type -->
    <ng-container *ngSwitchDefault [ngSwitch]="column.template">
      <td
        *ngSwitchDefault
        fes-table-view-default-cell-renderer
        [column]="column"
        [record]="record"
        [tableComponent]="taskTable"
      ></td>
    </ng-container>
  </ng-container>

</ng-template>

<app-volunteer-handsets-table
  [cellRendererTmplRef]="cellRendererTmpl"
  [tabConfig]="tabConfig"
  [detailFn]="detailFn"
  [isActiveView]="tabConfig.active"
  [contextJson]="tabConfig.viewInfo.id"
  (contextJsonChange)="contextJsonChangeHandler($event, tabConfig)"
  #volunteerHandsetsTable
>
</app-volunteer-handsets-table>
